<template>
    <div class="d-flex">
        <b-button
            class="mr-1"
            variant="default"
            title="Nature of Incident"
            @click="$bvModal.show(incidentModalId)"
        >
            <font-awesome-icon :icon="['fas', 'bolt-lightning']" />
        </b-button>
        <b-button
            @click="$bvModal.show(notesModalId)"
            class="mr-1"
            title="Edit Notes"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'note-sticky']" />
        </b-button>
        <b-button
            :href="viewClaimHref"
            class="mr-1"
            title="View Claims"
            variant="default"
            target="_blank"
        >
            <font-awesome-icon :icon="['fas', 'eye']" />
        </b-button>
        <b-button
            target="_blank"
            :href="previewClaimHref"
            variant="default"
            title="Preview"
        >
            <font-awesome-icon :icon="['fas', 'file']" />
        </b-button>
        <modal ok-only :id="incidentModalId" title="Nature of Incident">
            <span
                >Nature of Incident that caused the damage:
                {{ natureOfIncident }}</span
            >
        </modal>
        <modal
            @ok.prevent="updateNote"
            @show="setNoteValue"
            :id="notesModalId"
            title="Edit Notes"
        >
            <form-textarea v-model="notes" :rows="3" />
        </modal>
    </div>
</template>

<script>
import Modal from '../../../generic/modal/modal.vue';
import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';

export default {
    components: {
        Modal,
        FormTextarea,
    },
    data() {
        return {
            notes: null,
        };
    },
    methods: {
        setNoteValue() {
            this.notes = this.params.data.admin_notes;
        },
        updateNote() {
            this.params &&
                this.params.updateNotes(this.notes, this.params.data.id);
        },
    },
    computed: {
        incidentModalId() {
            return 'incident-modal-' + this.params.data.id;
        },
        notesModalId() {
            return 'notes-modal-' + this.params.data.id;
        },
        natureOfIncident() {
            return this.params && this.params.data?.nature_of_incident;
        },
        viewClaimHref() {
            return (
                this.params &&
                '/app/damage-protection/claim/edit/' +
                    this.params.data.policy_id
            );
        },
        previewClaimHref() {
            return (
                this.params &&
                '/app/damage-protection/claim/' + this.params.data.id + '/pdf/'
            );
        },
    },
};
</script>

<style>
</style>